import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { whatsappLink } from "../lib/api";

const WhatsAppFloatingButton = () => (
  <motion.a
    data-testid="whatsapp-floating-btn"
    href={whatsappLink("Hello Pacific Gold, I would like to inquire about a wholesale gold order")}
    target="_blank"
    rel="noopener noreferrer"
    initial={{ opacity: 0, scale: 0.6, y: 20 }}
    animate={{ opacity: 1, scale: 1, y: 0 }}
    transition={{ delay: 1.6, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
    whileHover={{ scale: 1.06 }}
    whileTap={{ scale: 0.95 }}
    className="fixed bottom-6 right-6 z-40 flex items-center gap-3 rounded-full bg-[#141312] border border-[#C5A059]/50 pl-4 pr-5 py-3 shadow-[0_10px_30px_-10px_rgba(20,19,18,0.45)]"
    aria-label="Chat with us on WhatsApp"
  >
    <span className="relative flex h-9 w-9 items-center justify-center rounded-full bg-[#D4AF37] text-[#141312]">
      <MessageCircle size={17} />
      <span className="absolute -top-0.5 -right-0.5 h-2.5 w-2.5 rounded-full bg-emerald-400 border-2 border-[#141312]" />
    </span>
    <span className="hidden sm:block leading-tight">
      <span className="block text-[10px] tracking-[0.2em] uppercase text-[#FAF8F5]/60">Sales desk</span>
      <span className="block font-mono text-xs text-[#FAF8F5]">+1 672 889 9844</span>
    </span>
  </motion.a>
);

export default WhatsAppFloatingButton;
